<mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="space-between center">
  <div>Assets</div>
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="refreshAssets()">
      <mat-icon>refresh</mat-icon>
      <span>Refresh</span>
    </button>
  </mat-menu>
</mat-toolbar>

<div class="assets-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container" fxLayout="column" fxLayoutAlign="center center">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading assets...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && assets.length === 0" class="empty-state" fxLayout="column" fxLayoutAlign="center center">
    <mat-icon>account_balance_wallet</mat-icon>
    <h3>No Assets Found</h3>
    <p>Request demo tokens to get started</p>
  </div>

  <!-- Assets Grid -->
  <div *ngIf="!isLoading && assets.length > 0" class="assets-grid" fxLayout="row wrap" fxLayoutGap="16px grid">
    <div *ngFor="let asset of assets" fxFlex="100%" fxFlex.gt-xs="50%" fxFlex.gt-sm="33%" fxFlex.gt-md="25%">
      <ssi-asset-card
        [asset]="asset"
        (transfer)="routeTransfer($event)"
      ></ssi-asset-card>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="footer-section" fxLayout="column" fxLayoutAlign="center center">
  <div class="address-display">
    <span class="label">Your Address:</span>
    <span class="address" [matTooltip]="getPublicKey()" matTooltipPosition="above">
      {{ getPublicKey() | slice:0:6 }}...{{ getPublicKey() | slice:-4 }}
    </span>
    <button mat-icon-button (click)="copyAddress()" matTooltip="Copy address">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
  <button mat-raised-button color="primary" (click)="getZeroTokens()" class="request-tokens-btn">
    <mat-icon>add_circle</mat-icon>
    Request Demo Tokens
  </button>
</div>
